import React from 'react';
import classNames from 'classnames';
import css from './BlueLayout.module.css';
import { useAuthBtn } from '../use-auth-btn';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';
import { LoginLikeLayout } from './LoginLikeLayout';
import { SignUpLikeLayout } from './SingUpLikeLayout';
import { G2BadgeTop50, MetaBadge } from '@mm/icons';
import { LoginType } from '@mm/state/controllers/SessionController';
import { HighLevelSignupLayout } from './HighLevelSignupLayout';
import { Iconiq } from './Iconiq';

type Props = {
  className?: string;
  children?: any;
  hideTrial?: boolean;
  type?: LoginType;
};

export const BlueLayout = ({ className, children, hideTrial, type }: Props) => {
  const { isSignIn, isLogIn, isResetPassword } = useAuthBtn();

  const isLoginLike = isSignIn || isLogIn || isResetPassword;
  const isHighLevel = type === LoginType.highLevel;

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <Logo className={css.desktopLogo} />
        <div className={css.left}>
          <div className={css.description}>
            {isLoginLike ? (
              <LoginLikeLayout />
            ) : isHighLevel ? (
              <HighLevelSignupLayout />
            ) : (
              <SignUpLikeLayout hideTrial={hideTrial} />
            )}
          </div>
        </div>
        <div className={classNames(css.right)}>
          {isLoginLike && (
            <div className={css.badges}>
              <G2BadgeTop50 />
              <Iconiq />
              <MetaBadge className={css.badge} />
            </div>
          )}
          <Logo
            className={classNames(css.logo, { [css.signupLogo]: !isLoginLike })}
          />
          {children}
        </div>
      </div>
    </div>
  );
};
